import { useContext } from 'react';
import { useSuspenseQuery, type UseSuspenseQueryResult } from '@tanstack/react-query';

import {
  fetchMatchesCouponData,
  getMatchesCouponCacheKey,
  type MatchesCouponRequestParams,
} from '../api/cx-api.service';
import { MatchesCouponContext } from '../context';
import { type MatchesCouponResponseData } from '../interfaces/matches-coupon.interface';

import { useMatchesCouponContext } from './useMatchesCouponContext';

export const useData = (): UseSuspenseQueryResult<MatchesCouponResponseData | null> => {
  const store = useContext(MatchesCouponContext);
  if (!store) throw new Error('Missing MatchesCouponContext.Provider in the tree');

  const apiKey = useMatchesCouponContext(state => state.apiKey);
  const bettypeIds = useMatchesCouponContext(state => state.bettypeIds || []);
  const countryCode = useMatchesCouponContext(state => state.countryCode);
  const dataApiEndpoint = useMatchesCouponContext(state => state.dataApiEndpoint);
  const eventId = useMatchesCouponContext(state => state.eventId);
  const overrideBookies = useMatchesCouponContext(state => state.overrideBookies);
  const repub = useMatchesCouponContext(state => state.repub);
  const subdivision = useMatchesCouponContext(state => state.subdivision);
  const subeventLimit = useMatchesCouponContext(state => state.subeventLimit);

  const requestParams: MatchesCouponRequestParams = {
    bettypeIds,
    countryCode,
    dataApiEndpoint,
    eventId,
    overrideBookies,
    repub,
    requestUrl: '',
    subdivision,
    subeventLimit,
  };

  return useSuspenseQuery<MatchesCouponResponseData | null>({
    queryFn: () =>
      fetchMatchesCouponData(dataApiEndpoint, requestParams, {
        apiKey,
        logger: console,
      }),
    queryKey: getMatchesCouponCacheKey(requestParams),
  });
};
